import { defineStore } from "pinia";
import { User } from "@/models/User";
import { $Amplify } from "@/main";
import { useCognitoAdmin } from "@/store/cognitoAdmin";
import { CognitoUserSession } from "amazon-cognito-identity-js";

interface UserAdminState {
  users: User[];
  groups: string[];
  currentUser: string;
}
export const useUserAdmin = defineStore("userAdmin", {
  state: (): UserAdminState => ({
    users: [],
    groups: [],
    currentUser: "",
  }),
  actions: {
    resetPassword(username: string) {
      return useCognitoAdmin()
        .resetPassword({
          UserPoolId: $Amplify.Auth._config.userPoolId,
          Username: username,
        })
        .then((res: any) => console.log(res, "res from password testData"));
    },
    createUser(createPayload: {
      UserPoolId: string;
      Username: string;
      UserAttributes: [{ Name: string; Value: string }];
      ValidationData: [{ Name: string; Value: string }];
    }) {
      return useCognitoAdmin().createUser(createPayload);
    },
    deleteUser(Username: string) {
      return useCognitoAdmin().deleteUser({
        UserPoolId: $Amplify.Auth._config.userPoolId,
        Username,
      });
    },
    updateUser(editPayload: {
      Username: string;
      attributes: [{ Name: string; Value: string }];
    }) {
      return useCognitoAdmin().updateUserAttributes({
        Username: editPayload.Username,
        UserPoolId: $Amplify.Auth._config.userPoolId,
        UserAttributes: editPayload.attributes,
      });
    },
    updateUserGroup(payload: { Username: string; GroupName: string }) {
      return useCognitoAdmin().addUserToGroup({
        Username: payload.Username,
        GroupName: payload.GroupName,
        UserPoolId: $Amplify.Auth._config.userPoolId,
      });
    },
    removeUserFromGroup(payload: { Username: string; GroupName: string }) {
      return useCognitoAdmin().removeUserFromGroup({
        Username: payload.Username,
        GroupName: payload.GroupName,
        UserPoolId: $Amplify.Auth._config.userPoolId,
      });
    },
    getGroups() {
      return useCognitoAdmin()
        .listGroupNames()
        .then((data: string[]) => {
          this.groups = data;
        });
    },
    getUsers() {
      return useCognitoAdmin()
        .listUsers()
        .then((data: User[]) => {
          this.users = data;
        });
    },
    getCurrentUser() {
      return $Amplify.Auth.currentSession().then((r: CognitoUserSession) => {
        this.currentUser = r.getAccessToken().payload.username;
      });
    },
  },
});
